import { render } from "./form.vue?vue&type=template&id=28124dc6&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=28124dc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28124dc6"

export default script